import * as React from 'react';
import {connect} from "react-redux";
import {Customer, CustomerDescriptor} from "../../models/Customer";
import {ApplicationState} from "../../store";
import {CustomerList} from '../components/CustomerList';
import {ColumnData} from '../../models/ColumnData';
import {TabsService} from '../TabsService';
import {Tab, TabTypes} from '../Tab';
import {actionCustomerFetchAll, actionDeleteCustomer, actionDeleteCustomers} from '../../store/customers/actions'
import {Button} from "@material-ui/core";
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded";
import {t} from "../../core/localization";

export interface CustomersTabProps {
	customers: Customer[]
	tab: Tab
}

export interface CustomersTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		customers: state.customers.list,
		tab: state.tabs.active
	};
}

class CustomersTab extends React.Component<CustomersTabProps, CustomersTabState> {

	constructor(props: CustomersTabProps) {
		super(props)
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: CustomersTabProps) {
	}

	componentDidMount() {
		actionCustomerFetchAll();
	}

	onOpenClick(customer: Customer){
		TabsService.createTab(t.Customer + ': ' + customer.title, TabTypes.CUSTOMERS_NEW, customer)
	}

	onCopyClick(customer: Customer){
		TabsService.createTab(t.Customer + ': ' + customer.title, TabTypes.CUSTOMERS_NEW, { ...customer, id: null })
	}

	onDeleteClick(customer: Customer){
		actionDeleteCustomer(customer);
	}

	onActionDeleteClick(customers: Customer[]){
		actionDeleteCustomers(customers);
	}

	onNewClick() {
		TabsService.createTab(t.NewCustomer, TabTypes.CUSTOMERS_NEW, new Customer())
	}

	render(): React.ReactNode {

		const {customers} = this.props;

		const columns = [
			// new ColumnData("id", "id"),
			new ColumnData(t.Title, "title"),
			new ColumnData(t.VatId, "vatId"),
			new ColumnData(t.Saldo, "saldo")
		];

		return (
			<div style={{padding: '10px'}}>
				<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewCustomer}</Button></div>

				<CustomerList
					columns={columns}
					items={customers}
					title={t.Customers}
					onOpenClick={(customer: Customer) => this.onOpenClick(customer)}
					onCopyClick={(customer: Customer) => this.onCopyClick(customer)}
					onDeleteClick={(customer: Customer) => this.onDeleteClick(customer)}
					onActionDeleteClick={(customers: Customer[]) => this.onActionDeleteClick(customers)}
					tab={this.props.tab}
					descriptor={CustomerDescriptor}
				/>
			</div>
		);
	}
}

export default connect(mapStateToProps)(CustomersTab);
